import React from 'react';
import {Link} from 'react-router-dom';

class BoxesItem extends React.Component {
    render() {
        const {box} = this.props;
        const {id, created, closed_at} = box;
        const createdAtText = created && new Date(created).toLocaleString('en-GB');
        const closedAtText = closed_at && new Date(closed_at).toLocaleString('en-GB');

        return (
            <tr className="BoxesItem">
                <td className="text-primary">#{id}</td>
                <td>{createdAtText}</td>
                <td>{closedAtText}</td>
                <td>
                    <Link to={'/boxes2/' + id}>Xem thùng</Link>
                </td>
            </tr>
        );
    }
}

export default BoxesItem;
